<div class="dashboard-study-researcher" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="30px">
  <div class="dashboard-study-researcher__header" fxLayout="row" fxLayoutAlign="start center">
    <button mat-icon-button color="primary" aria-label="Back to Researchers" (click)="backToResearchers()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="dashboard-study-researcher__header-title">
      {{
        isAddResearcher
          ? 'Add researcher to study'
          : selectedStudyResearcher?.firstname + ' ' + selectedStudyResearcher?.lastname
      }}
    </div>
  </div>
  <form
    [formGroup]="researcherForm"
    class="dashboard-study-researcher__info"
    dashboardConnectForm
    [connectForm]="isAddResearcher ? newStudyResearcher : selectedStudyResearcher"
    *ngrxLet="privilegesOpened$ as privilegesOpened"
    fxLayout="column"
    fxLayoutAlign="space-between stretch"
    fxLayoutGap="15px"
  >
    <mat-form-field fxFlex="100">
      <input matInput formControlName="email" placeholder="E-mail" />
      <mat-error *ngIf="email.hasError('required')"> Email is <strong>required</strong> </mat-error>
      <mat-error *ngIf="email.hasError('pattern')">
        E-mail must be in format <strong>example@example.com</strong>
      </mat-error>
    </mat-form-field>
    <button
      mat-raised-button
      color="accent"
      fxFlexAlign="start"
      type="button"
      *ngIf="isAddResearcher && !privilegesOpened"
      (click)="checkEmail()"
    >
      {{ 'Check email' | uppercase }}
    </button>
    <div fxLayoutGap="25px" *ngIf="!isAddResearcher || (isAddResearcher && privilegesOpened)">
      <mat-form-field fxFlex="50">
        <input
          matInput
          formControlName="firstname"
          placeholder="First Name"
          (ngModelChange)="credentialsOnChange($event)"
        />
        <mat-error *ngIf="firstName.hasError('required')"> First Name is <strong>required</strong> </mat-error>
        <mat-error *ngIf="firstName.hasError('maxlength')">
          First Name needs to have
          <strong>at most {{ firstName.errors?.maxlength.requiredLength }}</strong>
          characters
        </mat-error>
      </mat-form-field>
      <mat-form-field fxFlex="50">
        <input
          matInput
          formControlName="lastname"
          placeholder="Last Name"
          (ngModelChange)="credentialsOnChange($event)"
        />
        <mat-error *ngIf="lastName.hasError('required')"> Last Name is <strong>required</strong> </mat-error>
        <mat-error *ngIf="lastName.hasError('maxlength')">
          Last Name needs to have
          <strong>at most {{ lastName.errors?.maxlength.requiredLength }}</strong>
          characters
        </mat-error>
      </mat-form-field>
    </div>
    <div
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      fxLayoutGap="30px"
      *ngIf="!isAddResearcher || (isAddResearcher && privilegesOpened)"
    >
      <ng-container
        *ngIf="
          selectedStudyResearcher?.id !== selectedStudy?.researcherId &&
          ((!isAddResearcher && selectedStudyResearcher?.id !== currentUser?.id) ||
            (isAddResearcher && newStudyResearcher?.id !== currentUser?.id))
        "
      >
        <div class="dashboard-study-researcher__header-title">Privileges</div>
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          formArrayName="privileges"
          *ngFor="let section of privileges?.controls; let s = index"
        >
          <label fxFlex="20"
            >{{ tableSectionLabels[s] === 'Interventions' ? 'Interventions' : tableSectionLabels[s] }}
          </label>
          <div [formGroupName]="s" fxFlex="80" fxLayout="column" fxLayoutAlign="center stretch">
            <mat-radio-group formControlName="action" fxLayout="row" fxLayoutAlign="space-between center">
              <mat-radio-button
                *ngFor="let action of privilegeActions; let a = index"
                [value]="action"
                aria-label="Select an option"
                >{{ tableActionLabels[a] }}</mat-radio-button
              >
            </mat-radio-group>
          </div>
        </div>
      </ng-container>
      <button
        mat-raised-button
        color="primary"
        fxFlexOffset="30px"
        fxFlexAlign="end"
        *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.RESEARCHERS, PRIVILEGE_ACTIONS.ALL)"
        type="submit"
        (click)="saveStudyResearcher()"
        [disabled]="!nameChange && !isAddResearcher"
      >
        {{
          isAddResearcher && !newStudyResearcher ? ('Add Researcher' | uppercase) : ('Update Researcher' | uppercase)
        }}
      </button>
    </div>
  </form>
</div>
